/**
 * Saga-Review Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-saga-review.md
 */

const NOW = Date.now();
const COMPENSATIONS = [
  {
    id: 'comp_001',
    job_id: 'job_42c',
    job_type: 'hosting.provision',
    step: 2,
    action: 'domain.unwind',
    plugin_id: 'registrar-inwx',
    status: 'review_required',
    payload: { domain: 'example.de', order_id: '2026-12345' },
    error: 'hosting-Step 3 failed: enhance_account_create_timeout',
    tenant_id: 3,
    created_at: new Date(NOW - 2 * 3600_000).toISOString(),
  },
  {
    id: 'comp_002',
    job_id: 'job_55a',
    job_type: 'cloud.provision',
    step: 1,
    action: 'hosting.terminate',
    plugin_id: 'hosting-enhance',
    status: 'failed',
    payload: { account_id: 'acc-991' },
    error: 'argocd_app_create_failed: namespace_exists',
    tenant_id: 3,
    created_at: new Date(NOW - 18 * 3600_000).toISOString(),
  },
];

export function sagaReviewFixture({ status, action, tenantId } = {}) {
  let list = COMPENSATIONS;
  if (status) list = list.filter((c) => c.status === status);
  if (action) list = list.filter((c) => c.action === action);
  if (tenantId) list = list.filter((c) => String(c.tenant_id) === String(tenantId));
  return { compensations: list };
}
